import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

document.addEventListener('DOMContentLoaded', () => {
  console.log('Initialized Clerk Data Fetch');
  const clerk_wrappers = document.querySelectorAll('.clerk-swiper-wrapper');
  
  clerk_wrappers.forEach(clerk_wrapper => {
    const endpoint = clerk_wrapper.dataset.endpoint;
    const category = parseInt(clerk_wrapper.dataset.category);
    const limit = parseInt(clerk_wrapper.dataset.limit);
    const label = clerk_wrapper.dataset.labels;
  
    const output = clerk_wrapper;
    let product;

    if(clerk_wrapper.closest(".minicart__clerk-placeholder")) {
      const productsArray = JSON.parse(clerk_wrapper.dataset.products);
      product = parseInt(productsArray.map(Number).join(','));
    }
    else if (window.location.pathname.includes("products")) {
      product = clerk_wrapper.dataset.product;
    } else if (window.location.pathname.includes("cart")) {
      const productsArray = JSON.parse(clerk_wrapper.dataset.products);
      product = parseInt(productsArray.map(Number).join(','));
    }
  
    const fetchResponse = (callback) => {
      try {
        window.Clerk('call', endpoint, {
          attributes: ['id', 'handle'],
          limit: limit,
          products: [product],
          labels: [label],
          category: category
        }, callback);
  
      } catch (error) {
        console.error('Clerk "call" function failed immediately.', error);
      }
    }
  
    const fetchProduct = async ({ handle, id }) => {
      const result = await fetch(`/products/${handle}?view=view`);
      const html = await result.text();
      const node = document.createElement('div');
      node.innerHTML = html;
  
      const productHtml = node.firstElementChild;
      const links = productHtml.querySelectorAll('a');
      const buttons = productHtml.querySelectorAll('button');
  
      links.forEach(link => {
        link.setAttribute('data-clerk-product-id', id);
        
      });
      buttons.forEach(button => {
        button.setAttribute('data-clerk-product-id', id);
      });
  
      return productHtml.outerHTML;
    }
  
    const getProducts = async (products) => {
      const promises = products.map(product => fetchProduct(product));
      return Promise.all(promises);
    }
  
    const initClerk = async () => {
      if (!window.Clerk) {
        return;
      }

      const handleClerkResponse = async (response) => {
        try {
          console.log('Clerk API response:', response);

          if (!response) {
            throw new Error(`Response is null or undefined. Server may have failed to respond.`);
          }
          if (response.product_data == 0) {
            throw new Error('Product data is 0.');
          }
          if (response.status !== 'ok') {
            throw new Error(
              `Could not fetch Clerk by endpoint: "${endpoint}". Server responded with: ${response.status}`,
            );
          }

          const { product_data: products, result } = response;

          if (result.length === 0) {
            console.log('No results');
          }

          const productsHTML = await getProducts(products);
          output.innerHTML = '';
    
          productsHTML.forEach((product) => {
            output.insertAdjacentHTML(
              'beforeend',
              `${product}`,
            );
          });
    
          window.Clerk('click', '*[data-clerk-product-id]');

          if (clerk_wrapper.closest(".minicart__clerk-placeholder")) {
            const existing = clerk_wrapper.closest('.clerk-swiper');
            const minicartTarget = document.querySelector('.minicart-clerk-element');
            let clone = existing.cloneNode(true);
            minicartTarget.appendChild(clone);
            window.Moonbase.initClerkMiniCartSwiper(clone);
          }

        } catch (error) {
          console.error(error);
        }
      };

      fetchResponse(handleClerkResponse);
    }
  
    initClerk();
  });
});

// Every time Liquid Ajax Cart updates, it resets the Clerk slider (since this is added dynamically with JS) so this restores it
document.addEventListener("liquid-ajax-cart:request-end", function(event) {
  const {requestState} = event.detail;
  
  if (requestState.info.initiator !== "mutation") {
    console.log("liquid-ajax-cart:request-end");

    waitForMinicartTarget((minicartTarget) => {
      const existing = document.querySelector('.minicart__clerk-placeholder .clerk-swiper');
      if (existing) {
        const clone = existing.cloneNode(true);
        minicartTarget.appendChild(clone);
        window.Moonbase.initClerkMiniCartSwiper(clone);
      }
    });
  }
});

function waitForMinicartTarget(callback) {
  const targetSelector = '.minicart-clerk-element';
  const existing = document.querySelector(targetSelector);

  if (existing) {
    callback(existing);
    return;
  }

  const observer = new MutationObserver((mutations, obs) => {
    const el = document.querySelector(targetSelector);
    if (el) {
      obs.disconnect();
      callback(el);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', () => {
  var clerk_swiper = new Swiper('.clerk-swiper:not(.minicart)', {
    "rewind": true,
    "navigation": {
      "nextEl": ".clerk-next-button",
      "prevEl": ".clerk-prev-button"
    },
    "spaceBetween": 5,
    "pagination": { 
      "el": ".clerk-pagination",
      "clickable": true
    },
    "slidesPerView": 1,
    "breakpoints": {
      "640": {
        "slidesPerView": 1,
        "spaceBetween": 5
      },
      "768": {
        "slidesPerView": 1,
        "spaceBetween": 5
      },
      "1024": {
        "slidesPerView": 4,
        "spaceBetween": 5
      }
    },
    on: {
    init: function () {
      this.slides.forEach((slide, index) => {
        slide.setAttribute('data-swiper-slide-index', index);
      });
    },
    slideChange: function () {
      this.slides.forEach((slide, index) => {
        slide.setAttribute('data-swiper-slide-index', index);
      });
    }
  }
  });

  var clerk_swiper_minicart = new Swiper('.clerk-swiper.minicart', {
    "rewind": true,
    "navigation": {
      "nextEl": ".clerk-next-button",
      "prevEl": ".clerk-prev-button"
    },
    "spaceBetween": 5,
    "pagination": { 
      "el": ".clerk-pagination",
      "clickable": true
    },
    "slidesPerView": 1,
    on: {
    init: function () {
      this.slides.forEach((slide, index) => {
        slide.setAttribute('data-swiper-slide-index', index);
      });
    },
    slideChange: function () {
      this.slides.forEach((slide, index) => {
        slide.setAttribute('data-swiper-slide-index', index);
      });
    }
  }
  });
});